import React from "react";
import { useTranslation } from "react-i18next";
import {useParams} from "react-router";
import {Breadcrumb, Col, Collapse, Row, Space, Table} from "antd";

import {
  ArrowRight,
  Bank,
  ChevronRight,
  Clock,
  Document,
  MoneyBagCoin,
  User,
} from "assets/icons";

import Spacer from "components/Spacer";
import Container from "components/Container";
import { useSingle } from "modules/serviceRegister/hooks";

import cls from "./ServiceView.module.scss";
import MetaDataCard from "pages/ServiceRegister/components/MetaDataCard";

import davXizmat from "../../assets/images/davxizmat.png";

const ServicePoint = ({ imgSrc, title }) => {
  return (
    <div className={cls.servicePoint}>
      <img src={imgSrc} alt="service point" />
      <span>{title}</span>
      <ChevronRight />
    </div>
  );
};

const ServiceView = () => {
  const { t, i18n } = useTranslation();
  const { id } = useParams();

  const {item, isFetched} = useSingle({id});

  const text = `Sanitariya-muhofaza zonasida joylashgan obyektlar va inshootlarning profili oʻzgargan taqdirda ulardan xoʻjalik maqsadida foydalanish uchun ruxsatnoma`;

  const items = [
    {
      key: "1",
      label: "Davlat xizmatini ko‘rsatishda kelishiladigan organlar",
        children: <p>{item?.organizations?.map(value => <div>{value.name[i18n.language]}</div>)}</p>,
    },
    {
      key: "2",
      label:
        "Davlat xizmatini foydalanish uchun zarur boshqa turdagi ma’muriy tartib taomillar",
        children: <p>{item?.principles?.map(value => <div>{value}</div>)}</p>,
    },
    {
      key: "3",
      label: "Davlat xizmatini ko‘rsatish nuqtasi va axborot tizim(lar)i",
      children: <p>{text}</p>,
    },
    {
      key: "4",
      label: "Xizmatni olish uchun kerakli hujjatlar",
      children: <p>{text}</p>,
    },
    {
      key: "5",
      label: "To‘lov ma’lumotlari",
        children: <div>
            {
                item.payments?.map(value => <div key={value.id} className={cls.item} >
                    <p>{t(value.type)}:</p>
                    <p>{value.payment_value.toLocaleString('ru-RU')}</p>
                </div>)
            }
        </div>,
    },
    {
      key: "6",
      label: "Davlat xizmatidan foydalanish uchun zarur talab va shartlar",
        children: <p>{item?.requirements?.map(value => <div>{value}</div>)}</p>,
    },
    {
      key: "7",
      label: "Davlat xizmatini ko‘rsatish natijasining amal qilish muddati",
      children: <p>{text}</p>,
    },
  ];

  return (
    <Container>
      <Spacer size={35} />

      <Breadcrumb separator=">">
        <Breadcrumb.Item href="/">{t("home")}</Breadcrumb.Item>
        <Breadcrumb.Item href="/service-register">
          {t("service_register")}
        </Breadcrumb.Item>
        <Breadcrumb.Item>{t("service")}</Breadcrumb.Item>
      </Breadcrumb>

      <Spacer size={32} />

      <div className={cls.content}>
        <div className={cls.flex}>
          <div className={cls.left}>
            <span className={cls.title}>
              Turizm {">"} Turizm operatori faoliyati uchun sertifikat...
            </span>
            <strong className={cls.largeTitle}>
                {item.serviceName ? item.serviceName[i18n.language] : ''}
            </strong>
          </div>

          <div className={cls.right}>
            <span className={cls.title}>BOB RAQAMI</span>
            <strong className={cls.largeTitle}>{item.uniqueNumber}</strong>
          </div>
        </div>
      </div>
      <div className={cls.center}>
        <Row gutter={[8, 8]} align={'stretch'}>
          <Col xs={24} sm={12} lg={6}>
            <MetaDataCard
              icon={<Clock />}
              title="Arizani ko‘rib chiqish muddatlari"
              text="Avtomatik tarzda"
            />
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <MetaDataCard
              icon={<Document />}
              title="Davlat xizmatini ko‘rsatish natijasi"
              text={item?.serviceResult}
            />
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <MetaDataCard
              icon={<User />}
              title="Ariza beruvchilar toifasi"
              text={t(item?.subjectType)}
            />
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <MetaDataCard
              icon={<MoneyBagCoin />}
              title="Xizmat narxi"
              text={t(item?.paymentType)}
            />
          </Col>
        </Row>
        <Spacer size={32} />
        <Row gutter={[24]}>
          <Col xs={24} sm={12} lg={16}>
            <Collapse size="large" items={items} bordered={false} />
          </Col>
          <Col xs={24} sm={12} lg={8}>
            <Space
              direction="vertical"
              size="middle"
              style={{ display: "flex" }}>
              <MetaDataCard
                icon={<Bank />}
                title="Vakolatli organ"
                text={item?.organization?.name[i18n.language]}
                background="grey"
              />
              <Space size={16} />
              <MetaDataCard
                title="Xizmat ko‘rsatish nuqtasi va axborot tizim(lar)i"
                background="grey">
                <Space direction="vertical" style={{ display: "flex" }}>
                    {item?.informationSystems?.map(value => <ServicePoint key={value.name} imgSrc={davXizmat} title={value.name} />)}
                </Space>
              </MetaDataCard>
              <MetaDataCard
                icon={<Clock />}
                title="Natijaning amal qilish muddati"
                text={`${item?.validityPeriod?.value} ${t(item?.validityPeriod?.type)}`}
                background="grey"
              />
              <MetaDataCard
                icon={<Document />}
                title="Normativ hujjat"
                text="Avtomatik tarzda"
                background="grey"
              />
            </Space>
          </Col>
        </Row>
        <Spacer size={40} />
        <h2 className={cls.titleSecondary}>O‘zaro bog‘liq davlat xizmatlari</h2>
        <Spacer size={24} />
        <Row gutter={[16, 16]}>
          {Array.from({ length: 6 }, (_, i) => (
            <Col xs={24} sm={12} lg={6}>
              <div
                key={i}
                style={{
                  padding: "16px",
                  background: "#fff",
                  borderRadius: "16px",
                  boxShadow: "0 4px 16px rgba(4, 22, 116, 0.06)",
                }}>
                <p
                  style={{
                    fontSize: "14px",
                    lineHeight: "20px",
                    color: "#000c74",
                    marginBottom: "8px",
                  }}>
                  Turizm
                </p>
                <p
                  style={{
                    fontSize: "14px",
                    lineHeight: "20px",
                    color: "#0c0a15",
                    marginBottom: "20px",
                    fontWeight: 500,
                  }}>
                  Turizm operatori faoliyati uchun sertifikat (Turizm
                  sertifikati) olish — turistik xizmatlar ko‘rsatish huquqini
                  tasdiqlovchi hujjat
                </p>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "12px",
                    color: "#000C7499",
                  }}>
                  <span style={{ fontSize: "16px" }}>Batafsil</span>
                  <ArrowRight />
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </Container>
  );
};

export default ServiceView;
